export const PRODUCTS = [
  {
    id: "bevel",
    num: "01",
    name: "Spiral & Straight Bevel Gears",
    spec: "Up to Ø500 · 8 module · Gleason generated",
    desc: "Precision spiral and straight bevel gears ground on Gleason generators for high-load, low-noise power transmission.",
    img: "https://images.pexels.com/photos/28752154/pexels-photo-28752154.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    id: "spur",
    num: "02",
    name: "Spur Gears",
    spec: "Ø30mm – 1.5m · 1 to 16 module",
    desc: "Durable, high-workability spur gears manufactured to tight tolerances for reliable, efficient drives.",
    img: "https://images.pexels.com/photos/21854070/pexels-photo-21854070.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    id: "helical",
    num: "03",
    name: "Helical Gears",
    spec: "Ø30mm – 1.5m · 1 to 16 module",
    desc: "Low-vibration, low-noise helical gears engineered for wear resistance and long working life.",
    img: "https://images.unsplash.com/photo-1740209475472-aa7d280f7452?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "worm",
    num: "04",
    name: "Worm Wheels & Worm Shafts",
    spec: "Custom ratios · Bronze / steel pairing",
    desc: "Reliable worm wheels and shafts for compact, high-reduction, trouble-free drive systems.",
    img: "https://images.unsplash.com/photo-1736161999520-0a20fa297a89?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "sprockets",
    num: "05",
    name: "Sprockets",
    spec: "Single & duplex · Hardened teeth",
    desc: "Industrial sprockets and chain wheels built for heavy-duty conveying and transmission applications.",
    img: "https://images.unsplash.com/photo-1565153907400-7e01a9ab25f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "gearboxes",
    num: "06",
    name: "Industrial Gearboxes",
    spec: "Fully customisable to spec",
    desc: "Corrosion-resistant industrial gearboxes engineered and customised to your exact application.",
    img: "https://images.unsplash.com/photo-1736161999319-808bb8e66300?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "assemblies",
    num: "07",
    name: "Roller & Wheel Assemblies",
    spec: "Crane · Furnace · Charging rollers",
    desc: "Water-cooled charging/discharging rollers, crane and furnace wheel assemblies for steel plants.",
    img: "https://images.unsplash.com/photo-1713244433542-4c6205d09d97?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "usp",
    num: "08",
    name: "USP & Custom Components",
    spec: "Gears up to 2m dia · Build to print",
    desc: "You say it, we build it. Bespoke precision spare parts machined from your drawings and specifications.",
    img: "https://images.unsplash.com/photo-1666634157070-6fd830fb5672?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const INDUSTRIES = [
  {
    id: "oilgas",
    name: "Oil & Gas",
    desc: "High-integrity gearing and components for drilling, pumping and process equipment.",
    img: "https://images.unsplash.com/photo-1633829131104-e2134f75c6e5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "defence",
    name: "Defence",
    desc: "Mission-critical precision parts trusted by defence establishments and OEMs.",
    img: "https://images.pexels.com/photos/11349469/pexels-photo-11349469.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
  {
    id: "agriculture",
    name: "Agricultural Equipment",
    desc: "Rugged transmission components engineered for the field and heavy machinery.",
    img: "https://images.unsplash.com/photo-1606739211185-2c846d734a6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "concrete",
    name: "Concrete Batching Plants",
    desc: "Durable gearboxes and drives built to run in abrasive, high-load environments.",
    img: "https://images.pexels.com/photos/1058141/pexels-photo-1058141.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Precision, measured in microns.",
    body: "Every gear is generated, ground and inspected against CMM data. From 1 to 16 module and up to two metres in diameter — tolerances hold where it matters.",
  },
  {
    num: "02",
    title: "Three decades at the machine.",
    body: "Backed by an ISO 9001 certified manufacturing partner running Gleason generators, CNC turning, hobbing and gear grinding since 1988.",
  },
  {
    num: "03",
    title: "Your partner in the GTA.",
    body: "Exon Global bridges world-class Indian manufacturing to Tier-2 and Tier-3 clients across Canada — local accountability, global capability.",
  },
];

export const CLIENTS = [
  "Bharat Forge", "Kalyani Steels", "JSW Steel", "John Deere",
  "Tata Steel", "ArcelorMittal", "ISMT Ltd", "Jindal Saw",
  "Mahindra Sanyo", "Ramakrishna Forgings", "Essar Steel", "VRDE Defence",
];

export const CAPABILITIES = [
  { k: "Gleason bevel generators", v: "Ø500 × 8 module" },
  { k: "Max gear diameter", v: "2 metres" },
  { k: "Module range", v: "1 – 16 module" },
  { k: "CNC turning · VMC · hobbing", v: "German / HMT / Haas" },
  { k: "Quality system", v: "ISO 9001 certified" },
  { k: "Inspection", v: "CMM + Gleason testers" },
];

export const CATEGORIES = [
  "Spiral / Bevel Gears", "Spur Gears", "Helical Gears", "Worm Wheels & Shafts",
  "Sprockets", "Industrial Gearboxes", "Roller / Wheel Assemblies", "Custom / Build-to-print",
];

export const INDUSTRY_OPTIONS = ["Oil & Gas", "Defence", "Agricultural Equipment", "Concrete Batching Plant", "Other"];

export const REGIONS = ["North America", "Europe", "Middle East", "Asia Pacific", "Africa", "South America"];
export const VOLUMES = ["Prototype / 1–50", "Small batch / 51–500", "Mid volume / 501–5,000", "High volume / 5,000+"];
